import { render, staticRenderFns } from "./TimeLine.vue?vue&type=template&id=5f0f13f4&scoped=true&"
import script from "./TimeLine.vue?vue&type=script&lang=js&"
export * from "./TimeLine.vue?vue&type=script&lang=js&"
import style0 from "./TimeLine.vue?vue&type=style&index=0&id=5f0f13f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f13f4",
  null
  
)

export default component.exports
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTimeline,QTimelineEntry});
